"use strict";

angular.module('app.modals.editDatapoints', [])

    .controller('editDatapointsModalCtrl', ['$scope', '$state', 'close', 'f_User', '$q', 'Datapoints','Title','sceneSelectDataSourceModal','__SceneSourceData','Options','infoGuideModal',
        function ($scope, $state, close, f_User, $q, Datapoints,Title,sceneSelectDataSourceModal,__SceneSourceData,Options,infoGuideModal) {

              $scope.init = function(){

                $scope.Datapoints = Datapoints;
                $scope.User = f_User;
                $scope.Title = Title;
                  $scope.Options = Options;

            };
            $scope.close = function () {

                    close();
            }
            $scope.save = function(a)
            {
                close(a);
            }
            $scope.infoGuide = function(a)
            {
                infoGuideModal(a);
            }

            var oldDatapoint;
            var dpCopy;
            var originalDatapointType;
            $scope.setSourceFor = function(list,index)
            {
                var Datapoint = list[index];
                if (!originalDatapointType) {
                    if (Datapoint.DatapointType) {
                        originalDatapointType = Datapoint.DatapointType;
                    }
                }

                if (Datapoint.ConstantValue === undefined) {
                    let oldDatapointConfig;
                    if (
                        Datapoint.$UI
                        && Datapoint.$UI.$ConstantDatapoint
                        && Datapoint.$UI.$ConstantDatapoint.DatapointConfig
                    ) {
                        oldDatapointConfig = angular.copy(Datapoint.$UI.$ConstantDatapoint.DatapointConfig);
                        if ([2,4].includes(oldDatapointConfig.DatapointType)) {
                            oldDatapointConfig.DefaultValue = 0;
                        }
                    }
                    else {
                        if (!Datapoint.DatapointType) {
                            Datapoint.DatapointType = originalDatapointType;
                        }
                        if (Datapoint.DatapointType === 4
                            && Datapoint.$UI.$Datapoint.DatapointConfig.DatapointType !== Datapoint.DatapointType) {
                            Datapoint.$UI.$Datapoint.DatapointConfig.DatapointType = 4;
                        }
                        oldDatapointConfig = {
                            DatapointType: Datapoint.$UI.$Datapoint.DatapointConfig.DatapointType,
                            DefaultValue: 0
                        };
                    }

                    if (!dpCopy) {
                        dpCopy = angular.copy(Datapoint);
                        delete dpCopy.$UI.$Datapoint;
                        delete dpCopy.$UI.$Device;
                    }

                    Datapoint = __SceneSourceData.$buildRaw({
                        $type: 'BMS.Shared.SceneData.Sources.SceneDataSourceConstant, BMS.Shared',
                        DatapointType: oldDatapointConfig.DatapointType,
                        ConstantValue: oldDatapointConfig.DefaultValue
                    });
                    Datapoint.$UI = dpCopy.$UI;
                    Datapoint.$UI.DisplayName = dpCopy.$UI.DisplayName;
                    Datapoint.$UI.switchable = true;
                    list[index] = Datapoint;
                }else{
                    oldDatapoint = Datapoint;
                    dpCopy = angular.copy(Datapoint);

                    sceneSelectDataSourceModal(Datapoint.$UI.$Datapoint).then(function(modal){
                        modal.close.then(function(data){
                            if (data) {
                               /* console.log(Datapoint);
                                console.log(data);
                                Datapoint._type = data._type;
                                Datapoint.DatapointValue = data.DatapointValue;
                                Datapoint.$Datapoint = data.$Datapoint;
                                Datapoint.$Device = data.$Device; */

                                var o = {};
                                o.$type = 'BMS.Shared.SceneData.Sources.SceneDataSourceRawDatapoint, BMS.Shared';
                                o.DatapointValue = data.DatapointValue;
                                o.$UI = oldDatapoint.$UI;
                                o.$UI.$Datapoint = data.$UI.$Datapoint;
                                o.$UI.$Device = data.$UI.$Device;
                                o.$UI.$ConstantDatapoint = oldDatapoint.$UI.$ConstantDatapoint;
                                //o.$Device = data.$UI.$Device;
                                o.BufferedValuesCount = data.BufferedValuesCount;
                                o.Method = data.Method;

                                Datapoint = __SceneSourceData.$buildRaw(o);
                                Datapoint.$UI = o.$UI;
                                Datapoint.$UI.DisplayName = oldDatapoint.$UI.DisplayName;
                                Datapoint.$UI.switchable = true;
                                list[index] = Datapoint;
                            }
                        })
                    });
                }

            }/*
            $scope.toggleSourceFor = function (Datapoint) {
                console.log(Datapoint);
                if (Datapoint.SourceData.ConstantValue == undefined) {
                    Datapoint.SourceData = __SceneSourceData.$buildRaw({
                        $type: 'BMS.Shared.SceneData.Sources.SceneDataSourceConstant, BMS.Shared',
                        DatapointType: Datapoint.$UI.$Datapoint.DatapointConfig.DatapointType,
                        ConstantValue: Datapoint.$UI.$Datapoint.DatapointConfig.DefaultValue
                    });
                } else {
                    sceneSelectDataSourceModal(Datapoint.$UI.$Datapoint).then(function (modal) {
                        modal.close.then(function (data) {
                            if (data) {



                            }
                        })
                    });
                }
            }*/

            $scope.init();
        }
    ])

    .factory('editDatapointsModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (Datapoints,Title,Options) {

            return ModalService.showModal({
                templateUrl: "views/modals/editDatapoints.html",
                controller: 'editDatapointsModalCtrl',
                inputs: {
                    Datapoints: Datapoints,
                    Title : Title,
                    Options : Options
                }
            });


        }
    }]);
